import React, { forwardRef } from 'react';

import { Select } from '@aline/common';
import type { ChipProps } from '@mui/material';
import { Chip } from '@mui/material';
import type { ContractTypeOption } from 'src/components/generic';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(_theme => ({
  chip: {
    maxWidth: '100%',
    // Needed so chip shrinks and shows ... when chip overflows container.
    overflow: 'hidden',
  },
}));

interface ContractTypeChipProps extends ChipProps {
  contractType: ContractTypeOption | null;
  fallbackText?: string;
}
export const ContractTypeChip = forwardRef(function ContractTypeChip(
  { contractType, fallbackText = 'Set Contract Type', ...chipProps }: ContractTypeChipProps,
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const { classes } = useStyles();

  return (
    <Chip
      ref={ref}
      className={classes.chip}
      data-cy={Select.document.editor.appBar.contractType}
      label={contractType?.value ?? fallbackText}
      size="small"
      variant="outlined"
      {...chipProps}
    />
  );
});
